import "./SubscribedUserHome.css";

import Header from "../../components/HomeHeader";
import PlanStatusView from "../PlanStatusView";
import Post from "../../components/Post";
import ProPodcast from "../../components/ProPodcast/ProPodcast";
import React from "react";
import RightView from "../../components/RightView/RightView";

function SubscribedUserHome({ homeData }) {
  return (
    <div className="subscribed-user-home">
      <PlanStatusView />
      <div className="main-container">
        <div className="first-frame">
          <Header />
          <Post homeData={homeData} />
        </div>

        <div className="second-frame">
          <RightView homeData={homeData} />
          {homeData?.podcasts?.length > 0 && (
            <ProPodcast podcasts={homeData.podcasts} />
          )}
        </div>
      </div>
    </div>
  );
}

export default SubscribedUserHome;
